import { buildOrderListSchema } from './order_list_filter_schema';

app.ThirdPartyOrderListView = app.PaginatedListView.extend({
  initialize(options) {
    app.PaginatedListView.prototype.initialize.call(this, {
      title: 'Third Party Orders',
      subtitle: `All times are in ${app.location.getTimezoneAbbr()}`,
      cellView: app.ThirdPartyOrderCellView,
      searchEnabled: false,
      isLocalSearch: false,
      showTimestampsInLocationTimezone: true,
      filterSchemaButton: true,
      filterSchema: buildOrderListSchema(true),
      ...options,
    });
  },

  __navigateToModel(order) {
    this.scrollToItemWithId(order.id, true);
  },

  render() {
    if (this.collection.filterFieldGroupView) {
      this.options.filterValue = this.collection.filterFieldGroupView.getValue();
    }
    return app.PaginatedListView.prototype.render.apply(this, arguments);
  },
});
